import { Form, Input, Button, message, TimePicker, DatePicker } from "antd";
import axios from "axios";
import dayjs from "dayjs";

function MembershipForm({ initialValues = null, onSuccess }) {
  const [form] = Form.useForm();

  const handleSubmit = async (values) => {
    const startTime = values.slot;
    const endTime = startTime.add(1, "hour");

    const payload = {
      ...values,
      joiningDate: values.joiningDate.format("YYYY-MM-DD"),
      slot: `${startTime.format("h:mm A")} - ${endTime.format("h:mm A")}`
    };

    try {
      if (initialValues) {
        await axios.put(
          `https://uxzsrd33be23alhtpfmy5ziuc40vnldo.lambda-url.us-east-1.on.aws/admin/memberships/${initialValues.membershipId}`,
          payload
        );
        message.success("Membership updated successfully!");
      }

      form.resetFields();
      if (onSuccess) onSuccess();
    } catch (err) {
      console.error("Error:", err);
      message.error("Failed to save membership");
    }
  };

  return (
    <div className="space-y-2 mb-4">
      {initialValues && (
        <div className="bg-gray-100 p-4 rounded border mb-4 text-sm">
          <p><strong>👤 Name:</strong> {initialValues.userName}</p>
          <p><strong>📋 Plan Name:</strong> {initialValues.planName}</p>
          <p><strong>📅 Submit Date:</strong> {dayjs(initialValues.submitDate).format("DD-MM-YYYY")}</p>
          <p><strong>🧾 Payment Screenshot:</strong>{" "}
            <a
              href={initialValues.paymentURL}
              target="_blank"
              rel="noreferrer"
              className="text-blue-600 underline"
            >
              View Screenshot
            </a>
          </p>
        </div>
      )}

      <Form
        form={form}
        layout="vertical"
        initialValues={
          initialValues
            ? {
                ...initialValues,
                joiningDate: dayjs(initialValues.joiningDate),
                slot: dayjs(initialValues.slot, "h:mm A")
              }
            : {}
        }
        onFinish={handleSubmit}
      >
        <Form.Item name="slot" label="Slot Time" rules={[{ required: true }]}>
          <TimePicker use12Hours format="h:mm A" />
        </Form.Item>
        <Form.Item name="joiningDate" label="Joining Date" rules={[{ required: true }]}>
          <DatePicker format="YYYY-MM-DD" />
        </Form.Item>
        <Form.Item>
          <Button type="primary" htmlType="submit">
            {initialValues ? "Update Membership" : "Add Membership"}
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
}

export default MembershipForm;
